// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { IFormCoupon } from '~/utils/interface/coupon';

export const schema = (t: TFunction): yup.ObjectSchema<IFormCoupon> => {
  return yup.object().shape({
    name: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    discountRate: yup.number().required(t('common_validate_field_required', { ns: 'common/base' })),
    discountType: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    quantity: yup.number().optional(),
    startDate: yup.string().optional(),
    endDate: yup.string().optional(),
    status: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    isNoExpiration: yup.boolean().optional(),
  });
};

export const defaultValuesCouponForm: IFormCoupon = {};
